/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Rule_Sets_Create_Link_Display_NameInputs */

const en_forms_rule_sets_create_link_display_name = /** @type {(inputs: Forms_Rule_Sets_Create_Link_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Display Name`)
};

const de_forms_rule_sets_create_link_display_name = /** @type {(inputs: Forms_Rule_Sets_Create_Link_Display_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link Angezeigter Name`)
};

/**
* | output |
* | --- |
* | "Link Display Name" |
*
* @param {Forms_Rule_Sets_Create_Link_Display_NameInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_rule_sets_create_link_display_name = /** @type {((inputs?: Forms_Rule_Sets_Create_Link_Display_NameInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Rule_Sets_Create_Link_Display_NameInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_rule_sets_create_link_display_name(inputs)
	return de_forms_rule_sets_create_link_display_name(inputs)
});